import { Content } from '@tiptap/core'

import { EditorText } from '../../EditorText'
import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type MentionProps = BaseNotificationItemProps & {
  userName: string
  message: string
  type: 'mention'
  targetEntityId: string
}

export function Mention({ userName, message, targetEntityId, ...props }: MentionProps) {
  return (
    <NotificationItem
      {...props}
      title={`${userName} mentioned you in a comment`}
      subTitle={targetEntityId}
      descriptionAddon={
        <div className='flex text-left text-sm text-gray-500'>
          <p className='flex items-baseline'>
            <b className='min-w-fit'>{userName}</b>
            <p className='mr-1 ml-1'>wrote:</p>
            <EditorText initialData={JSON.parse(message) as Content} editable={false} truncateText hasQuote />
          </p>
        </div>
      }
    />
  )
}
